import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import BadgeGenerator from './BadgeGenerator';

const Hero = () => {
    return (
        <section className="min-h-screen flex flex-col justify-center items-center text-center px-4 pt-28 pb-12 relative overflow-hidden">
            {/* Background Elements */}
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600/20 rounded-full blur-[128px] -z-10" />
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-green-500/20 rounded-full blur-[128px] -z-10" />

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="max-w-5xl mx-auto flex flex-col justify-center w-full"
            >
                <div className="space-y-6 mb-8">
                    <h2 className="text-5xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-br from-white via-gray-200 to-gray-600">
                        Recursive Tits!
                    </h2>
                    <a
                        href="https://www.tokenstrategy.com/strategies/0x6b6994b20be17f193d67886592b3dad5df594060"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-3 px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full backdrop-blur-sm transition-all duration-300 group"
                    >
                        <span className="text-lg font-medium">Powered by Token Works</span>
                        <ExternalLink className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
                    </a>

                    <div className="max-w-3xl mx-auto text-left bg-white/5 p-8 rounded-2xl border border-white/10 backdrop-blur-sm space-y-6">
                        <div className="space-y-4">
                            <p className="text-gray-300 leading-relaxed text-lg">
                                <span className="text-green-400 font-semibold">Recursive Strategies</span> are new assets that buy themselves instead of an underlying asset using a 10% trading fee. Why use this for tits? For the culture!
                            </p>

                        </div>

                        <div className="space-y-3 text-gray-400 border-t border-white/5 pt-4">
                            <p className="font-semibold text-white">Of the 10% trading fee:</p>
                            <ul className="grid sm:grid-cols-2 gap-2 list-disc list-inside">
                                <li><span className="text-green-400">8%</span> rebuys the strategy</li>
                                <li><span className="text-purple-400">1%</span> creator royalties</li>
                                <li><span className="text-pink-400">0.8%</span> burns $PNKSTR</li>
                                <li><span className="text-blue-400">0.2%</span> to TokenWorks</li>
                            </ul>
                            <p className="pt-2 text-xs italic opacity-80">
                                Trading fees pool up, and every 30 minutes all funds in the pool are used to buy and burn the STR token. This fee mechanism encourages long-term holding and prevents overtrading.
                            </p>
                        </div>




                    </div>
                </div>

                <div className="space-y-8">
                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >

                    </motion.div>



                    <BadgeGenerator />

                    <div className="w-full max-w-5xl mx-auto h-[600px] border border-white/10 rounded-xl overflow-hidden shadow-2xl bg-black/50 backdrop-blur-sm">
                        <iframe
                            height="100%"
                            width="100%"
                            id="geckoterminal-embed"
                            title="GeckoTerminal Embed"
                            src="https://www.geckoterminal.com/eth/pools/0x5e2ef48b2bbfe931223a9c84e4ef4e6224dfec2d9087468c492f9a2529cf8598?embed=1&info=1&swaps=1&grayscale=0&light_chart=0&chart_type=price&resolution=15m"
                            frameBorder="0"
                            allow="clipboard-write"
                            allowFullScreen
                        />
                    </div>

                    <p className="text-xs text-gray-600 max-w-lg mx-auto">
                        Disclaimer: Nothing is financial advice and $TITSTR is a meme token.
                    </p>
                </div>
            </motion.div>
        </section>
    );
};

export default Hero;
